export default {
  'reset_your_password': 'Reset Your Password',
  'reset_password': 'Reset Password',
  'new_password': 'New Password',
  'return_to_sign_in': 'Return to Sign In',
  'unknown_error': 'There was an error resetting your password, please try again.',
  'your_password_has_been_reset': 'Your password has been reset.',
};
